<template lang="html">
    <section class="pagination-nav"><b-pagination-nav :link-gen="linkGen" :number-of-pages="meta.totalPage" :value="page" /></section>
</template>

<script lang="js">
  import {BPaginationNav} from "bootstrap-vue";
  export default  {
    name: 'pagination',
    props: ["componentName", "meta", "page"],
    components: { 'b-pagination-nav': BPaginationNav },
    data() {
      return {
      }
    },
    methods: {
        linkGen (pageNum) {
            return { name: this.componentName, query: {type: this.$route.query.type, search: this.$route.query.search, offset: pageNum } };
        }
    }
}
</script>

<style scoped lang="scss">
.pagination-nav {
    display: inline-block;
}
</style>



// WEBPACK FOOTER //
// pagination.vue?e77f4dc2